import { MyleHelper } from "@/Common/Helpers/MyleHelper";
import { IPADisplaySettingsModel } from "../UI/IPADisplaySettingsModel";

class PADisplaySettings {
    public IsAllSitesChecked: boolean;
    public IsAllEmployeesChecked: boolean;
    public IsAllStatusChecked: boolean;
    public IsShowOnlySelectedSitesChecked: boolean;

    public EmployeeIds: string[];
    public SiteIds: string[];
    public StatusesIds: string[];

    public static FromModel(model: IPADisplaySettingsModel): PADisplaySettings {
        const helper = new MyleHelper();

        const display: PADisplaySettings = new PADisplaySettings();

        display.IsAllSitesChecked = model.get("IsAllSitesChecked");
        display.IsAllEmployeesChecked = model.get("IsAllEmployeesChecked");
        display.IsAllStatusChecked = model.get("IsAllStatusChecked");
        display.IsShowOnlySelectedSitesChecked = model.get("IsShowOnlySelectedSitesChecked");

        display.EmployeeIds = helper.GetCheckedItemsFromICheckableList(model.get("EmployeesGlobalCache")).map(checkable => checkable.Id).toArray();
        display.SiteIds = helper.GetCheckedItemsFromICheckableList(model.get("Sites")).map(checkable => checkable.Id).toArray();
        display.StatusesIds = helper.GetCheckedItemsFromICheckableList(model.get("AppointmentStatuses")).map(checkable => checkable.Id).toArray();

        return display;
    }
}

export { PADisplaySettings };
